class CustomCollectionGrid extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('[data-collection-search]');
    this.sortSelect = this.querySelector('[data-collection-sort]');
    this.grid = this.querySelector('[data-collection-grid]');
    this.count = this.querySelector('[data-collection-count]');
    this.loadMoreButton = this.querySelector('[data-load-more]');
    this.emptyState = this.querySelector('[data-empty-state]');
    this.cards = Array.from(this.querySelectorAll('[data-collection-card]'));
    this.visibleLimit = 6;

    this.searchInput?.addEventListener('input', () => {
      this.visibleLimit = 6;
      this.update();
    });

    this.sortSelect?.addEventListener('change', () => {
      this.visibleLimit = 6;
      this.update();
    });

    this.loadMoreButton?.addEventListener('click', () => {
      this.visibleLimit += 6;
      this.update();
    });

    this.update();
  }

  update() {
    const query = this.searchInput?.value.trim().toLocaleLowerCase() || '';
    const sort = this.sortSelect?.value || 'featured';
    const matchingCards = this.cards.filter((card) => card.dataset.searchValue.includes(query));

    matchingCards.sort((firstCard, secondCard) => {
      if (sort === 'title-ascending') {
        return firstCard.dataset.title.localeCompare(secondCard.dataset.title, undefined, { sensitivity: 'base' });
      }

      if (sort === 'title-descending') {
        return secondCard.dataset.title.localeCompare(firstCard.dataset.title, undefined, { sensitivity: 'base' });
      }

      return Number(firstCard.dataset.featuredOrder) - Number(secondCard.dataset.featuredOrder);
    });

    matchingCards.forEach((card) => this.grid?.append(card));
    const matchingSet = new Set(matchingCards);

    this.cards.forEach((card) => {
      card.hidden = true;
    });

    matchingCards.slice(0, this.visibleLimit).forEach((card) => {
      card.hidden = false;
    });

    if (this.count) this.count.textContent = String(matchingCards.length);
    if (this.emptyState) this.emptyState.hidden = matchingCards.length !== 0;
    if (this.loadMoreButton) this.loadMoreButton.hidden = matchingCards.length <= this.visibleLimit;

    this.cards
      .filter((card) => !matchingSet.has(card))
      .forEach((card) => this.grid?.append(card));
  }
}

if (!customElements.get('custom-collection-grid')) {
  customElements.define('custom-collection-grid', CustomCollectionGrid);
}
